import styled, { css } from 'styled-components';
import { SonntagButtonV2 } from "../Buttons/SonntagButtonV2";

export const Main = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Main", componentId: "sc-4xj5pz-0" })(["width:100%;user-select:none;"]);




export const Info = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Info", componentId: "sc-4xj5pz-1" })(["display:flex;justify-content:space-between;", " ", ""],



(props) => css(["padding:0 ", " ", " ", ";color:", ";"],
props.theme.spacers.M, props.theme.spacers.L, props.theme.spacers.M,
props.theme.colors['Level 4']),


(props) => css(props.theme.typography.SmallCapsHeadline));


export const Content = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Content", componentId: "sc-4xj5pz-2" })(["display:grid;grid-template-columns:minmax(0,1fr);grid-template-rows:auto;grid-row-gap:", ";"],



(props) => props.theme.spacers.M);


export const Button = /*#__PURE__*/styled(SonntagButtonV2).withConfig({ displayName: "styled__Button", componentId: "sc-4xj5pz-3" })(["margin-top:", ";"],
(props) => props.theme.spacers.L);